import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  CircularProgress,
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Container, List, Text } from "./styles.js";
import { Button } from "@mui/material";
import { api } from "../../services/axios.js";
import { ModalAlertDiv } from "../../components/modal/style.jsx";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CheckIcon from "@mui/icons-material/Check";

import { encode } from "base-64";

export default function ChangePass() {
  const reg =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?!.*&)[a-zA-Z\d!"#$%'()*+,\-./:;<=>?@\[\\\]^_`{|}~]{8,10}$/;
  const upper = /^(?=.*[A-Z])/;
  const low = /^(?=.*[a-z])/;
  const special = /[^a-zA-Z0-9&\s]+/;

  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState("");
  const [alert, setAlert] = useState({ msg: "", status: "", code: "" });

  const onSubmit = () => {
    if (reg.test(text)) {
      api
        .post("/core/ajax/manager.users", {
          type: "createToken",
        })
        .then(() => {
          api
            .post("/core/ajax/manager.users", {
              pass: text.trim(),
              token: "token",
              type: "changePassword",
            })
            .then(function (res) {
              setShowModal(true);
              setAlert({
                code: res.data.code,
                msg: res.data.msg,
                status: res.data.status,
              });
              console.log(res.data);
            })
            .catch(function (error) {
              const obj = error.response.data;
              setAlert({ msg: obj.msg, status: obj.status, code: obj.code });
              console.log(error);
            });
        });
    }
  };

  return (
    <Container>
      <h2>Change Pass</h2>
      <section>
        <FormControl sx={{ width: "max" }} variant="filled">
          <InputLabel htmlFor="filled-adornment-password">Password</InputLabel>
          <FilledInput
            id="filled-adornment-password"
            type={showPassword ? "text" : "password"}
            onChange={(e) => {
              setText(e.target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <List>
          <Text>
            <CheckIcon
              color={text.length > 7 && text.length < 11 ? "success" : "error"}
              fontSize="8px"
            />
            <p>Minimo 8 e Maximo 10</p>
          </Text>
          <Text>
            <CheckIcon
              color={upper.test(text) ? "success" : "error"}
              fontSize="8px"
            />
            <p>Letra maiscula</p>
          </Text>
          <Text>
            <CheckIcon
              color={low.test(text) ? "success" : "error"}
              fontSize="8px"
            />
            <p>Letra minuscula</p>
          </Text>
          <Text>
            <CheckIcon
              color={special.test(text) ? "success" : "error"}
              fontSize="8px"
            />
            <p>
              Caracter especial (com exceção do <strong>"&"</strong>)
            </p>
          </Text>
        </List>
        <Button
          variant="contained"
          disabled={!reg.test(text)}
          onClick={onSubmit}
        >
          Change
        </Button>
      </section>
      <Modal
        open={showModal}
        onClose={() => {
          if (alert?.status?.toLowerCase() === "ok") {
            window.location.href = +"newweb/login?msg=logout";
            return null;
          }
          setShowModal(false);
          setAlert({ msg: "", status: undefined });
        }}
        // style={customStyles}
        className="mui-fixed"
      >
        <Box sx={customStylesAlert}>
          {alert.status === undefined ? (
            <ModalAlertDiv>
              <CircularProgress />
              <h2>Creating new Password...</h2>
              <p>Please, wait...</p>
            </ModalAlertDiv>
          ) : alert?.status?.toLowerCase() === "ok" ? (
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon
                color={"success"}
                style={{ fontSize: "4rem" }}
              />
              <h2>Success!</h2>

              <a href={"/newweb/login"}>
                <Button
                  onClick={() => {
                    setShowModal(false);
                  }}
                  variant="contained"
                >
                  Ok
                </Button>
              </a>
            </ModalAlertDiv>
          ) : (
            <ModalAlertDiv>
              <h3>Error :&#40;</h3>
              <h3>{alert.msg}</h3>
              <Button
                onClick={() => {
                  setShowModal(false);
                }}
                variant="contained"
              >
                Ok
              </Button>
            </ModalAlertDiv>
          )}
        </Box>
      </Modal>
    </Container>
  );
}

const customStylesAlert = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
  height: "40%",
  minWidth: "20%",
  maxWidth: "50%",
  backgroundColor: "#FFF",
  p: 4,
};
